/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Import_Map_TargetInputs */

const cs_import_map_target = /** @type {(inputs: Import_Map_TargetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pole ${i?.name}`)
};

const en_import_map_target = /** @type {(inputs: Import_Map_TargetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} field`)
};

/**
* | output |
* | --- |
* | "{name} field" |
*
* @param {Import_Map_TargetInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_map_target = /** @type {((inputs: Import_Map_TargetInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Map_TargetInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_map_target(inputs)
	return cs_import_map_target(inputs)
});